export const NavUrls = [
  {
    id: 1,
    name: "Home",
    link: "/",
    auth: false,
  },
  {
    id: 2,
    name: "Airlines",
    link: "/security",
    auth: false,
  },
  {
    id: 3,
    name: "Airports",
    link: "/packages",
    auth: false,
  },
  {
    id: 4,
    name: "Cheap Flights",
    link: "/services",
    auth: false,
  },
  {
    id: 5,
    name: "Destinations",
    link: "/faqs",
    auth: false,
  },
  {
    id: 6,
    name: "Travel Guides",
    link: "/contact",
    auth: false,
  },
];
